import { servicePayments } from "../servicePayments";

/**
 * Mirrors `IPayerSetupIntentResponse` from the payments service. Kept local
 * because the installed @wingspanhq/payments SDK predates the endpoint.
 *
 * `clientSecret` is optional: Stripe types `setup_intent.client_secret` as
 * nullable, and the service omits the field rather than sending a broken
 * secret. An absent secret means there is nothing to confirm.
 */
export type IPayerSetupIntentResponse = {
  clientSecret?: string;
};

/**
 * Creates a Stripe SetupIntent (3DS enforced) against the payer's Stripe
 * customer, creating that customer on first use. The returned client secret is
 * confirmed client-side so the card is authenticated before it is ever used
 * off-session for a funds movement.
 *
 * The service resolves the payer from the authenticated session, so `payerId`
 * only fills the route's path segment and must be the caller's own member id.
 */
export const createPayerSetupIntent = async (
  payerId: string
): Promise<IPayerSetupIntentResponse> => {
  const response = await servicePayments.post(`/payer/${payerId}/setup-intent`);
  return response.data;
};
